import clsx from 'clsx'
import { ReactNode } from 'react'
import Button, { ButtonProps } from '../Button/Button'
import Header from '../Header/Header'

export interface NarrativeHeroProps {
  /**
   * Copy for header/title
   */
  header: ReactNode
  /**
   * Optional copy for subheader/subtitle
   */
  subHeader?: ReactNode
  /**
   * Optional background image URL
   */
  backgroundImage?: string
  /**
   * Optional button configuration
   */
  button?: ButtonProps
}

export default function NarrativeHero({
  header,
  subHeader,
  backgroundImage,
  button,
}: NarrativeHeroProps) {
  return (
    <div
      className={clsx(
        'flex items-center relative px-6 py-10 lg:px-24 lg:py-20 bg-cover bg-center bg-no-repeat md:rounded-2xl overflow-hidden text-white bg-theme-primary min-h-[340px] md:min-h-[0px]',
        backgroundImage &&
          'before:absolute before:left-0 before:top-0 before:bg-black before:opacity-50 before:w-full before:h-full',
      )}
      style={{
        backgroundImage: backgroundImage
          ? `url(${backgroundImage})`
          : undefined,
        backgroundPosition: 'center',
        backgroundSize: 'cover', // Use consistent cover sizing
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div
        className={clsx(
          'flex justify-between items-center text-center relative w-full flex-col',
        )}
      >
        <Header
          as="h1"
          overrideClassName
          className={clsx(
            'type-display-3 lg:text-[60px] lg:max-w-[800px] md:max-w-[600px]',
          )}
        >
          {header}
        </Header>
        <p
          className={clsx(
            'type-body-3 lg:type-body-1 mt-4 lg:max-w-[800px] md:max-w-[600px]',
          )}
        >
          {subHeader}
        </p>
        {button && (
          <div className="mt-8">
            <Button {...button} />
          </div>
        )}
      </div>
    </div>
  )
}
